<template>
  <div>
    <Modal v-model="showModal" title="编辑">
      <Form :model="timeForm" inline :rules="timeRules" ref="timeForm">
        <FormItem prop="start">
          <TimePicker type="time" placeholder="开始时间" style="width: 220px" format="HH:mm" v-model="timeForm.start"></TimePicker>
        </FormItem>
        <FormItem prop="end">
          <TimePicker type="time" placeholder="结束时间" style="width: 220px" format="HH:mm" v-model="timeForm.end"></TimePicker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="small" @click="saveTime('timeForm')">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    name:'time_Form',
    data(){
      return{
        showModal:false,
        timeForm:{
          id:null,
          start:'',
          end:''
        },
        timeRules:{
          start:[{required:true,message:'请选择开始时间',trigger:'change'}],
          end:[{required:true,message:'请选择结束时间',trigger:'change'}]
        }
      }
    },
    methods:{
      saveTime(name){
        let self = this;
        self.$refs[name].validate((valid) => {
          if (valid) {
            this.$api.setting.saveTime(this.packagingFormData()).then(res=>{
              if(res.state=="ok"){
                this.$Message.success("保存成功")
                this.$emit("refresh")
              }else{
                this.$Message.error(res.msg)
              }
              this.showModal=false
            })
          }
          else{
            this.$Message.error("表单验证不通过")
          }
        })
      },
      packagingFormData(){
        let postFormData = {};
        for (var i in this.timeForm) {
          if (this.timeForm.hasOwnProperty(i)) {
            postFormData['time.'+i] = this.timeForm[i];
          }
        }
        postFormData['time.id']=this.timeForm.id
        return postFormData;
      },
      init(){
        this.timeForm.id=''
        this.$refs.timeForm.resetFields()
      }
    }
  }
</script>
